











































































































import Vue from 'vue';

export default Vue.extend({
  name: 'UnternehmenItem',
  props: ['lehrstelle'],

  computed: {
    link(): string {
      return `/lehrstelle/${this.lehrstelle.id}`;
    },
    ort: function() {
      if (this.lehrstelle.location != this.lehrstelle.bezirk) {
        return `${this.lehrstelle.location}, ${this.lehrstelle.bezirk}`;
      }

      return this.lehrstelle.location;
    },
  },
});
